import "./assets/telegram-icon.scss";
import icon from "./assets/telegram.png";
import {LinkExternal} from "../links";

export default function TelegramIcon() {
  return (
    <LinkExternal to={'https://t.me/vsesib_olymp'}>
      <img className={'telegram-icon'} src={icon} alt={'tg'}/>
    </LinkExternal>
  );
}
